import React from 'react';
import { connect } from 'react-redux';
var selfStyles = require('./HeaderItemBrand.scss');
var crimpLogo = require('src/assets/logo/favicon-64.png');
var HeaderItemBrand = function (props) {
    var event = props.workspaceEvent.event;
    var imageLogo = event.logoUrl || event.logoIdenticon || crimpLogo;
    return (React.createElement("div", { className: selfStyles.brand },
        React.createElement("img", { src: imageLogo, className: selfStyles.brandLogo, alt: event.name || 'CRIMP' }),
        React.createElement("span", { className: selfStyles.brandName }, event.name)));
};
var mapStateToProps = function (state) { return ({
    workspaceEvent: {
        event: state.workspaceEvent.event && state.workspaceEvent.event.data[0],
    },
}); };
export default connect(mapStateToProps)(HeaderItemBrand);



//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageHeader/HeaderItemBrand.tsx
// module id = 632
// module chunks = 0